import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import FormConfigSectionQualifierForm from "./FormConfigSectionQualifierForm";
import { IFormConfigSectionQualifier } from "../../../model/formconfiguration/FormConfigSectionQualifier";

export interface State {}

export interface CreateFormConfigSectionQualifierFormProps
  extends FormComponentProps {
  translate: any;
  registerFormSubmitEventHandler?: any;
}

class CreateFormConfigSectionQualifierForm extends React.Component<
  CreateFormConfigSectionQualifierFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;

    registerFormSubmitEventHandler((e) => {
      e.preventDefault();
      let newFormConfigSectionQualifier = {} as IFormConfigSectionQualifier;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newFormConfigSectionQualifier.qualifier = {
            ...newFormConfigSectionQualifier.qualifier,
            ...values,
            valid: true
          };

          newFormConfigSectionQualifier.qualifier.description =
            values.qualifierDescription;

          newFormConfigSectionQualifier = {
            ...newFormConfigSectionQualifier,
            ...values,
            qualifierCode: values.code
          };
        }
      });
      return newFormConfigSectionQualifier;
    });
  }

  render() {
    const { translate } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <FormConfigSectionQualifierForm
        translate={translate}
        getFieldDecorator={getFieldDecorator}
      />
    );
  }
}

export default CreateFormConfigSectionQualifierForm;
